export const transformProductList = (productList: any[]): any => {
  if (!productList) {
    return [];
  }
  return productList?.map((product: any, index: number) => {
    const hasSku = product?.skus && product.skus.length > 0;
    const skuData = hasSku ? product.skus[0] : null;

    return {
      key: index + 1,
      variety: product?.commercial_name ?? "",
      manufacturer: product?.manufacturer ?? "",
      measure_unit: "",
      id: product?.id,
      seed_care: hasSku ? skuData?.seed_care ?? null : null,
      description: hasSku ? skuData?.material_description ?? null : null,
    };
  });
};
